// removed by extract-text-webpack-plugin
module.exports = {"panel":"panel__panel__1MY7m","panel__header":"panel__panel__header__1g7Ny","panel__text":"panel__panel__text__1Dzo0","title__notes":"panel__title__notes__2n_0A","panel__link":"panel__panel__link__1XcZI","content":"panel__content__3-vRL","content-star":"panel__content-star__1Dxq1","button":"panel__button__Kh_pR","button-second":"panel__button-second__llvhf","button__icon":"panel__button__icon__2qA7N","button-second__icon":"panel__button-second__icon__2WA34","buttons-container":"panel__buttons-container__1_wqH","link":"panel__link__ESEPC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/components/panel.scss
// module id = 1757
// module chunks = 1